export const EVENT_DISPLAY_TOAST = 'EVENT_DISPLAY_TOAST';
export const EVENT_GLOBAL_STATE = 'EVENT_GLOBAL_STATE';
